import {
  faApartment,
  faChairOffice,
  faFence,
  faFlag,
  faHotel,
  faHouse,
  faIndustry,
  faStore
} from '@fortawesome/pro-solid-svg-icons';

export const ACTIVITY_TYPE_CALL = 'Connect::Activities::Call';
export const ACTIVITY_TYPE_OTHER = 'Connect::Activities::Other';
export const ACTIVITY_TYPE_MEETING = 'Connect::Activities::Meeting';
export const ACTIVITY_TYPE_EMAIL = 'Connect::Activities::Email';
export const CONTACT_MODEL = 'Connect::Contact';
export const PERSON_MODEL = 'Connect::Person';
export const COMPANY_MODEL = 'Connect::Company';
export const PROPERTY_MODEL = 'Connect::Property';

export const TASK_PRIORITY_LOW = 'low';
export const TASK_PRIORITY_MEDIUM = 'medium';
export const TASK_PRIORITY_HIGH = 'high';

export const PROPERTY_TYPE_ICON_MAP = {
  1: faChairOffice,
  2: faStore,
  3: faIndustry,
  5: faFence,
  6: faApartment,
  7: faFlag,
  8: faHotel,
  10: faHouse
};

export const TENANT_EMPLOYEE_SIZE_MAP = {
  '0-25': '0-25',
  '25-100': '25-100',
  '100-250': '100-250',
  '250-1000': '250-1K',
  '1000-10000': '1K-10K',
  '10000-50000': '10K-50K',
  '50000-100000': '50K-100K',
  '>100000': 'Greater than 100K'
};

export const TENANT_SALES_REVENUE_MAP = {
  '0-1000000': 'Less than 1M',
  '1000000-10000000': '1M-10M',
  '10000000-50000000': '10M-50M',
  '50000000-100000000': '50M-100M',
  '100000000-250000000': '100M-250M',
  '250000000-500000000': '250M-500M',
  '500000000-1000000000': '500M-1B',
  '>1000000000': 'Greater than 1B'
};

export const TENANT_SIC_CODE_MAP = {
  '0111': 'Wheat',
  '0112': 'Rice',
  '0115': 'Corn',
  '0116': 'Soybeans',
  '0119': 'Cash Grains, Nec',
  '0131': 'Cotton',
  '0132': 'Tobacco',
  '0133': 'Sugarcane and Sugar Beets',
  '0134': 'Irish Potatoes',
  '0139': 'Field Crops, Except Cash Grain',
  '0161': 'Vegetables and Melons',
  '0171': 'Berry Crops',
  '0172': 'Grapes',
  '0173': 'Tree Nuts',
  '0174': 'Citrus Fruits',
  '0175': 'Deciduous Tree Fruits',
  '0179': 'Fruit and Tree Nuts, Nec',
  '0181': 'Ornamental Nursery Products',
  '0182': 'Food Crops Grown Undercover',
  '0191': 'General Farm, Primarily Crop',
  '0211': 'Beef Cattle Feedlots',
  '0212': 'Beef Cattle, Except Feedlots',
  '0213': 'Hogs',
  '0214': 'Sheeo and Goats',
  '0219': 'General Livestock, Nec',
  '0241': 'Dairy Farms',
  '0251': 'Broiler, Fryer, and Roaster Chickens',
  '0252': 'Chicken Eggs',
  '0253': 'Turkeys and Turkey Eggs',
  '0254': 'Poultry Hatcheries',
  '0259': 'Poultry and Eggs, Nec',
  '0271': 'Fur-bearing Animals and Rabbits',
  '0272': 'Horses and Other Equines',
  '0273': 'Animal Aquaculture',
  '0279': 'Animal Specialties, Nec',
  '0291': 'General Farms, Primarily animals',
  '0711': 'Soil Preparation Services',
  '0721': 'Crop Planting Protection',
  '0722': 'Crop Harvesting',
  '0723': 'Crop Preparatoin Services For Market',
  '0724': 'Cotton Ginning',
  '0741': 'Veterinary Services For Livestock',
  '0742': 'Veterinary Services, Specialties',
  '0751': 'Livestock Services, Except Veterinary',
  '0752': 'Animal Specialty Services',
  '0761': 'Farm Labor Contractors',
  '0762': 'Farm Management Services',
  '0781': 'Landscape Counseling and Planning',
  '0782': 'Lawn and Garden Services',
  '0783': 'Ornamental Shrub and Tree Services',
  '0811': 'Timber Tracts',
  '0831': 'Forest Products',
  '0851': 'Forestry Services',
  '0912': 'Finfish',
  '0913': 'Shellfish',
  '0919': 'Miscellaneous Marine Products',
  '0921': 'Fish Hatcheries and Preserves',
  '0971': 'Hunting and Trapping, and Game Propagation',
  '0900': 'Fishing, Hunting And Trapping',
  '1011': 'Iron Ores',
  '1021': 'Copper Ores',
  '1031': 'Lead and Zinc Ores',
  '1041': 'Gold Ores',
  '1044': 'Silver Ores',
  '1061': 'Ferroalloy Ores, Except Vanadium',
  '1094': 'Uranium-radium-vanadium Ores',
  '1099': 'Metal Ores, Nec',
  '1221': 'Bituminous Coal and Lignite-surface Mining',
  '1222': 'Bituminous Coal-underground Mining',
  '1231': 'Anthracite Mining',
  '1241': 'Coal Mining Services',
  '1311': 'Crude Petroleum and Natural Gas',
  '1321': 'Natural Gas Liquids',
  '1381': 'Drilling Oil and Gas Wells',
  '1382': 'Oil and Gas Exploration Services',
  '1389': 'Oil and Gas Field Services, Nec',
  '1411': 'Dimension Stone',
  '1422': 'Crushed and Broken Limestone',
  '1423': 'Crushed and Broken Granite',
  '1429': 'Crushed and Broken Stone, Not Elsewhere Classified',
  '1442': 'Construction Sand and Gravel',
  '1446': 'Industrial Sand',
  '1455': 'Kaolin and Ball Clay',
  '1459': 'Clay, Ceramic, and Refractory Minerals, Not Elsewhere Classified',
  '1474': 'Potash, Soda, and Borate Minerals',
  '1475': 'Phosphate Rock',
  '1479': 'Chemical and Fertilizer Mineral Mining, Not Elsewhere Classified',
  '1481': 'Nonmetallic Minerals Services, Except Fuels',
  '1499': 'Miscellaneous Nonmetallic Minerals, Except Fuels',
  '1521': 'Single-family Housing Construction',
  '1522': 'Residential Construction, Nec',
  '1531': 'Operative Builders',
  '1541': 'Industrial Buldings and Warehouses',
  '1542': 'Nonresidential Construction, Nec',
  '1611': 'Highway and Street Construction',
  '1622': 'Bridge, Tunnel, and Elevated Highway',
  '1623': 'Water, Sewer, and Utility Lines',
  '1629': 'Heavy Construction, Nec',
  '1711': 'Plumbing, Heating, and Air-Conditioning',
  '1721': 'Painting and Paper Hanging',
  '1731': 'Electrical Work',
  '1741': 'Masonry, Stone Setting, and Other Stone Work',
  '1742': 'Plastering, Drywall, Acoustical, and Insulation Work',
  '1751': 'Carpentry Work',
  '1752': 'Floor Laying and Other Floor Work, Not Elsewhere Classified',
  '1761': 'Roofing, Siding, and Sheet Metal Work',
  '1771': 'Concrete Work',
  '1781': 'Water Well Drilling',
  '1791': 'Structural Steel Erection',
  '1793': 'Glass and Glazing Work',
  '1794': 'Excavation Work',
  '1795': 'Wrecking and Demolition Work',
  '1796': 'Installation or Erection of Building Equipment, Not Elsewhere',
  '1799': 'Special Trade Contractors, Not Elsewhere Classified',
  '2011': 'Meat Packing Plants',
  '2013': 'Sausages and Other Prepared Meats',
  '2015': 'Poultry Slaughtering and Processing',
  '2021': 'Creamery Butter',
  '2022': 'Cheese; Natural and Processed',
  '2023': 'Dry, Condensed, Evaporated Products',
  '2024': 'Ice Cream and Frozen Desserts',
  '2026': 'Fluid Milk',
  '2032': 'Canned Specialties',
  '2033': 'Canned Fruits and Specialties',
  '2034': 'Dehydrated Fruits, Vegetables, Soups',
  '2035': 'Pickles, Sauces, and Salad Dressings',
  '2037': 'Frozen Fruits and Vegetables',
  '2038': 'Frozen Specialties, Nec',
  '2041': 'Flour and Other Grain Mill Products',
  '2043': 'Cereal Breakfast Foods',
  '2044': 'Rice Milling',
  '2045': 'Prepared Flour Mixes and Doughs',
  '2046': 'Wet Corn Milling',
  '2047': 'Dog and Cat Food',
  '2048': 'Prepared Feeds, Nec',
  '2051': 'Bread, Cake, and Related Products',
  '2052': 'Cookies and Crackers',
  '2053': 'Frozen Bakery Products, Except Bread',
  '2061': 'Raw Cane Suga',
  '2062': 'Cane Sugar Refinin',
  '2063': 'Beet Suga',
  '2064': 'Candy and Other Confectionery Products',
  '2066': 'Chocolate and Cocoa Products',
  '2067': 'Chewing Gu',
  '2068': 'Salted and Roasted Nuts and Seeds',
  '2074': 'Cottonseed Oil Mill',
  '2075': 'Soybean Oil Mills',
  '2076': 'Vegetable Oil Mills, Ne',
  '2077': 'Animal and Marine Fats and Oils',
  '2079': 'Edible Fats and Oils',
  '2082': 'Malt Beverages',
  '2083': 'Malt',
  '2084': 'Wines, Brandy, and Brandy Spirits',
  '2085': 'Distilled and Blended Liquors',
  '2086': 'Bottled and Canned Soft Drinks',
  '2087': 'Flavoring Extracts and Syrups, Nec',
  '2091': 'Canned and Cured Fish and Seafoods',
  '2092': 'Fresh or Frozen Packaged Fish',
  '2095': 'Roasted Coffee',
  '2096': 'Potato Chips and Similar Snacks',
  '2097': 'Manufactured Ice',
  '2098': 'Macaroni and Spaghetti',
  '2099': 'Food Preparations, Nec',
  '2111': 'Cigarettes',
  '2121': 'Cigars',
  '2131': 'Chewing and Smoking Tobacco',
  '2141': 'Tobacco Stemming and Redrying',
  '2211': 'Broadwoven Fabric Mills, Cotton',
  '2221': 'Broadwoven Fabric Mills, Manmade',
  '2231': 'Broadwoven Fabric Mills, Wool',
  '2241': 'Narrow Fabric Mills',
  '2251': "Women's Hosiery, Except Sock",
  '2252': 'Hosiery, Nec',
  '2253': 'Knit Outerwear Mills',
  '2254': 'Knit Underwear Mills',
  '2257': 'Weft Knit Fabric Mill',
  '2258': 'Lace and Warp Knit Fabric Mills',
  '2259': 'Knitting Mills, Ne',
  '2261': 'Finishing Plants, Cotton',
  '2262': 'Finishing Plants, Manmade',
  '2269': 'Finishing Plants, Nec',
  '2273': 'Carpets and Rugs',
  '2281': 'Yarn Spinning Mills',
  '2282': 'Throwing and Winding Mills',
  '2284': 'Thread Mills',
  '2295': 'Coated Fabrics, Not Rubberized',
  '2296': 'Tire Cord and Fabric',
  '2297': 'Nonwoven Fabrics',
  '2298': 'Cordage and Twine',
  '2299': 'Textile Goods, Nec',
  '2311': "Men's and Boy's Suits and Coats",
  '2321': "Men's and Boy's Furnishings",
  '2322': "Men's and Boy's Underwear and Nightwear",
  '2323': "Men's and Boy's Neckwear",
  '2325': "Men's and Boy's Trousers and Slacks",
  '2326': "Men's and Boy's Work Clothing",
  '2329': "Men's and Boy's Clothing, Nec",
  '2331': "Women's and Misses' Blouses and Shirts",
  '2335': "Women's, Junior's, and Misses' Dresses",
  '2337': "Women's and Misses' Suits and Coats",
  '2339': "Women's and Misses' Outerwear, Nec",
  '2341': "Women's and Children's Underwear",
  '2342': 'Bras, Girdles, and Allied Garments',
  '2353': 'Hats, Caps, and Millinery',
  '2361': "Girl's and Children's Dresses, Blouses",
  '2369': "Girl's and Children's Outerwear, Nec",
  '2371': 'Fur Goods',
  '2381': 'Fabric Dress and Work Gloves',
  '2384': 'Robes and Dressing Gown',
  '2385': 'Waterproof Outerwea',
  '2386': 'Leather and Sheep-lined Clothing',
  '2387': 'Apparel Belt',
  '2389': 'Apparel and Accessories, Nec',
  '2391': 'Curtains and Draperies',
  '2392': 'Household Furnishings, Nec',
  '2393': 'Textile Bags',
  '2394': 'Canvas and Related Products',
  '2395': 'Pleating and Stitching',
  '2396': 'Automotive and Apparel Trimmings',
  '2397': 'Schiffli Machine Embroiderie',
  '2399': 'Fabricated Textile Products, Nec',
  '2411': 'Logging',
  '2421': 'Sawmills and Planing Mills, General',
  '2426': 'Hardwood Dimension and Flooring Mills',
  '2429': 'Special Product Sawmills, Nec',
  '2431': 'Millwork',
  '2434': 'Wood Kitchen Cabinets',
  '2435': 'Hardwood Veneer and Plywood',
  '2436': 'Softwood Veneer and Plywoo',
  '2439': 'Structural Wood Members, Nec',
  '2441': 'Nailed Wood Boxes and Shook',
  '2448': 'Wood Pallets and Skids',
  '2449': 'Wood Containers, Nec',
  '2451': 'Mobile Homes',
  '2452': 'Prefabricated Wood Buildings',
  '2491': 'Wood Preserving',
  '2493': 'Reconstituted Wood Products',
  '2499': 'Wood Products, Nec',
  '2511': 'Wood Household Furniture',
  '2512': 'Upholstered Household Furniture',
  '2514': 'Metal Household Furniture',
  '2515': 'Mattresses and Bedsprings',
  '2517': 'Wood Television and Radio Cabinets',
  '2519': 'Household Furniture, Nec',
  '2521': 'Wood Office Furniture',
  '2522': 'Office Furniture, Except Wood',
  '2531': 'Public Building and Related Furniture',
  '2541': 'Wood Partitions and Fixtures',
  '2542': 'Partitions and Fixtures, Except Wood',
  '2591': 'Drapery Hardware and Blinds and Shades',
  '2599': 'Furniture and Fixtures, Nec',
  '2611': 'Pulp Mills',
  '2621': 'Paper Mills',
  '2631': 'Paperboard Mills',
  '2652': 'Setup Paperboard Boxe',
  '2653': 'Corrugated and Solid Fiber Boxes',
  '2655': 'Fiber Cans, Drums, and Similar Products',
  '2656': 'Sanitary Food Containers',
  '2657': 'Folding Paperboard Boxes',
  '2671': 'Paper; Coated and Laminated Packaging',
  '2672': 'Paper; Coated and Laminated, Nec',
  '2673': 'Bags: Plastic, Laminated, and Coated',
  '2674': 'Bags: Uncoated Paper and Multiwall',
  '2675': 'Die-cut Paper and Board',
  '2676': 'Sanitary Paper Products',
  '2677': 'Envelopes',
  '2678': 'Stationery Products',
  '2679': 'Converted Paper Products, Nec',
  '2711': 'Newspapers',
  '2721': 'Periodicals',
  '2731': 'Book Publishing',
  '2732': 'Book Printing',
  '2741': 'Miscellaneous Publishing',
  '2752': 'Commercial Printing, Lithographic',
  '2754': 'Commercial Printing, Gravure',
  '2759': 'Commercial Printing, Nec',
  '2761': 'Manifold Business Forms',
  '2771': 'Greeting Cards',
  '2782': 'Blankbooks and Looseleaf Binders',
  '2789': 'Bookbinding and Related Work',
  '2791': 'Typesetting',
  '2796': 'Platemaking Services',
  '2812': 'Alkalies and Chlorine',
  '2813': 'Industrial Gases',
  '2816': 'Inorganic Pigments',
  '2819': 'Industrial Inorganic Chemicals, Nec',
  '2821': 'Plastics Materials and Resins',
  '2822': 'Synthetic Rubber',
  '2823': 'Cellulosic Manmade Fiber',
  '2824': 'Organic Fibers, Noncellulosic',
  '2833': 'Medicinals and Botanicals',
  '2834': 'Pharmaceutical Preparations',
  '2835': 'Diagnostic Substances',
  '2836': 'Biological Products, Except Diagnostic',
  '2841': 'Soap and Other Detergents',
  '2842': 'Polishes and Sanitation Goods',
  '2843': 'Surface Active Agents',
  '2844': 'Toilet Preparations',
  '2851': 'Paints and Allied Products',
  '2861': 'Gum and Wood Chemical',
  '2865': 'Cyclic Crudes and Intermediates',
  '2869': 'Industrial Organic Chemicals, Nec',
  '2873': 'Nitrogenous Fertilizers',
  '2874': 'Phosphatic Fertilizers',
  '2875': 'Fertilizers, Mixing Only',
  '2879': 'Agricultural Chemicals, Nec',
  '2891': 'Adhesives and Sealants',
  '2892': 'Explosives',
  '2893': 'Printing Ink',
  '2895': 'Carbon Blac',
  '2899': 'Chemical Preparations, Nec',
  '2911': 'Petroleum Refining',
  '2951': 'Asphalt Paving Mixtures and Blocks',
  '2952': 'Asphalt Felts and Coatings',
  '2992': 'Lubricating Oils and Greases',
  '2999': 'Petroleum and Coal Products, Ne',
  '3011': 'Tires and Inner Tubes',
  '3021': 'Rubber and Plastics Footwear',
  '3052': 'Rubber and Plastics Hose and Beltings',
  '3053': 'Gaskets; Packing and Sealing Devices',
  '3061': 'Mechanical Rubber Goods',
  '3069': 'Fabricated Rubber Products, Nec',
  '3081': 'Unsupported Plastics Film and Sheet',
  '3082': 'Unsupported Plastics Profile Shapes',
  '3083': 'Laminated Plastics Plate and Sheet',
  '3084': 'Plastics Pipe',
  '3085': 'Plastics Bottles',
  '3086': 'Plastics Foam Products',
  '3087': 'Custom Compound Purchased Resins',
  '3088': 'Plastics Plumbing Fixtures',
  '3089': 'Plastics Products, Nec',
  '3111': 'Leather Tanning and Finishing',
  '3131': 'Footwear Cut Stock',
  '3142': 'House Slipper',
  '3143': "Men's Footwear, Except athletic",
  '3144': "Women's Footwear, Except athletic",
  '3149': 'Footwear, Except Rubber, Nec',
  '3151': 'Leather Gloves and Mittens',
  '3161': 'Luggage',
  '3171': "Women's Handbags and Purses",
  '3172': 'Personal Leather Goods, Nec',
  '3199': 'Leather Goods, Nec',
  '3211': 'Flat Glass',
  '3221': 'Glass Containers',
  '3229': 'Pressed and Blown Glass, Nec',
  '3231': 'Products of Purchased Glass',
  '3241': 'Cement, Hydraulic',
  '3251': 'Brick and Structural Clay Tile',
  '3253': 'Ceramic Wall and Floor Tile',
  '3255': 'Clay Refractories',
  '3259': 'Structural Clay Products, Ne',
  '3261': 'Vitreous Plumbing Fixtures',
  '3262': 'Vitreous China Table and Kitchenwar',
  '3263': 'Semivitreous Table and Kitchenwar',
  '3264': 'Porcelain Electrical Supplies',
  '3269': 'Pottery Products, Nec',
  '3271': 'Concrete Block and Brick',
  '3272': 'Concrete Products, Nec',
  '3273': 'Ready-mixed Concrete',
  '3274': 'Lime',
  '3275': 'Gypsum Products',
  '3281': 'Cut Stone and Stone Products',
  '3291': 'Abrasive Products',
  '3292': 'Asbestos Product',
  '3295': 'Minerals, Ground or Treated',
  '3296': 'Mineral Wool',
  '3297': 'Nonclay Refractories',
  '3299': 'Nonmetallic Mineral Products,',
  '3312': 'Blast Furnaces and Steel Mills',
  '3313': 'Electrometallurgical Product',
  '3315': 'Steel Wire and Related Products',
  '3316': 'Cold Finishing of Steel Shapes',
  '3317': 'Steel Pipe and Tubes',
  '3321': 'Gray and Ductile Iron Foundries',
  '3322': 'Malleable Iron Foundrie',
  '3324': 'Steel Investment Foundries',
  '3325': 'Steel Foundries, Nec',
  '3331': 'Primary Coppe',
  '3334': 'Primary Aluminum',
  '3339': 'Primary Nonferrous Metals, Nec',
  '3341': 'Secondary Nonferrous Metals',
  '3351': 'Copper Rolling and Drawing',
  '3353': 'Aluminum Sheet, Plate, and Foil',
  '3354': 'Aluminum Extruded Products',
  '3355': 'Aluminum Rolling and Drawing, Nec',
  '3356': 'Nonferrous Rolling and Drawing, Nec',
  '3357': 'Nonferrous Wiredrawing and Insulating',
  '3363': 'Aluminum Die-castings',
  '3364': 'Nonferrous Die-castings Except Aluminum',
  '3365': 'Aluminum Foundries',
  '3366': 'Copper Foundries',
  '3369': 'Nonferrous Foundries, Nec',
  '3398': 'Metal Heat Treating',
  '3399': 'Primary Metal Products',
  '3411': 'Metal Cans',
  '3412': 'Metal Barrels, Drums, and Pails',
  '3421': 'Cutlery',
  '3423': 'Hand and Edge Tools, Nec',
  '3425': 'Saw Blades and Handsaws',
  '3429': 'Hardware, Nec',
  '3431': 'Metal Sanitary Ware',
  '3432': 'Plumbing Fixture Fittings and Trim',
  '3433': 'Heating Equipment, Except Electric',
  '3441': 'Fabricated Structural Metal',
  '3442': 'Metal Doors, Sash, and Trim',
  '3443': 'Fabricated Plate Work (boiler Shop)',
  '3444': 'Sheet Metalwork',
  '3446': 'Architectural Metalwork',
  '3448': 'Prefabricated Metal Buildings',
  '3449': 'Miscellaneous Metalwork',
  '3451': 'Screw Machine Products',
  '3452': 'Bolts, Nuts, Rivets, and Washers',
  '3462': 'Iron and Steel Forgings',
  '3463': 'Nonferrous Forgings',
  '3465': 'Automotive Stampings',
  '3466': 'Crowns and Closure',
  '3469': 'Metal Stampings, Nec',
  '3471': 'Plating and Polishing',
  '3479': 'Metal Coating and Allied Services',
  '3482': 'Small Arms Ammunition',
  '3483': 'Ammunition, Except For Small Arms, Nec',
  '3484': 'Small Arms',
  '3489': 'Ordnance and Accessories, Nec',
  '3491': 'Industrial Valves',
  '3492': 'Fluid Power Valves and Hose Fittings',
  '3493': 'Steel Springs, Except Wire',
  '3494': 'Valves and Pipe Fittings, Nec',
  '3495': 'Wire Springs',
  '3496': 'Miscellaneous Fabricated Wire Products',
  '3497': 'Metal Foil and Lea',
  '3498': 'Fabricated Pipe and Fittings',
  '3499': 'Fabricated Metal Products, Nec',
  '3511': 'Turbines and Turbine Generator Sets',
  '3519': 'Internal Combustion Engines, Nec',
  '3523': 'Farm Machinery and Equipment',
  '3524': 'Lawn and Garden Equipment',
  '3531': 'Construction Machinery',
  '3532': 'Mining Machinery',
  '3533': 'Oil and Gas Field Machinery',
  '3534': 'Elevators and Moving Stairways',
  '3535': 'Conveyors and Conveying Equipment',
  '3536': 'Hoists, Cranes, and Monorails',
  '3537': 'Industrial Trucks and Tractors',
  '3541': 'Machine Tools, Metal Cutting Type',
  '3542': 'Machine Tools, Metal Forming Type',
  '3543': 'Industrial Patterns',
  '3544': 'Special Dies, Tools, Jigs, and Fixtures',
  '3545': 'Machine Tool Accessories',
  '3546': 'Power-driven Handtools',
  '3547': 'Rolling Mill Machinery',
  '3548': 'Welding Apparatus',
  '3549': 'Metalworking Machinery, Nec',
  '3552': 'Textile Machinery',
  '3553': 'Woodworking Machinery',
  '3554': 'Paper Industries Machinery',
  '3555': 'Printing Trades Machinery',
  '3556': 'Food Products Machinery',
  '3559': 'Special Industry Machinery, Nec',
  '3561': 'Pumps and Pumping Equipment',
  '3562': 'Ball and Roller Bearings',
  '3563': 'Air and Gas Compressors',
  '3564': 'Blowers and Fans',
  '3565': 'Packaging Machinery',
  '3566': 'Speed Changers, Drives, and Gears',
  '3567': 'Industrial Furnaces and Ovens',
  '3568': 'Power Transmission Equipment, Nec',
  '3569': 'General Industrial Machinery,',
  '3571': 'Electronic Computers',
  '3572': 'Computer Storage Devices',
  '3575': 'Computer Terminals',
  '3577': 'Computer Peripheral Equipment, Nec',
  '3578': 'Calculating and Accounting Equipment',
  '3579': 'Office Machines, Nec',
  '3581': 'Automatic Vending Machines',
  '3582': 'Commercial Laundry Equipment',
  '3585': 'Refrigeration and Heating Equipment',
  '3586': 'Measuring and Dispensing Pump',
  '3589': 'Service Industry Machinery, Nec',
  '3592': 'Carburetors, Pistons, Rings, Valves',
  '3593': 'Fluid Power Cylinders and Actuators',
  '3594': 'Fluid Power Pumps and Motors',
  '3596': 'Scales and Balances, Except Laboratory',
  '3599': 'Industrial Machinery, Nec',
  '3612': 'Power, Distribution and Specialty Transformers',
  '3613': 'Switchgear and Switchboard Apparatus',
  '3621': 'Motors and Generators',
  '3624': 'Carbon and Graphite Products',
  '3625': 'Relays and Industrial Controls',
  '3629': 'Electrical Industrial Apparatus',
  '3631': 'Household Cooking Equipment',
  '3632': 'Household Refrigerators and Freezer',
  '3633': 'Household Laundry Equipment',
  '3634': 'Electric Housewares and Fans',
  '3635': 'Household Vacuum Cleaners',
  '3639': 'Household Appliances, Nec',
  '3641': 'Electric Lamps',
  '3643': 'Current-carrying Wiring Devices',
  '3644': 'Noncurrent-carrying Wiring Devices',
  '3645': 'Residential Lighting Fixtures',
  '3646': 'Commercial Lighting Fixtures',
  '3647': 'Vehicular Lighting Equipment',
  '3648': 'Lighting Equipment, Nec',
  '3651': 'Household Audio and Video Equipment',
  '3652': 'Prerecorded Records and Tapes',
  '3661': 'Telephone and Telegraph Apparatus',
  '3663': 'Radio and T.v. Communications Equipment',
  '3669': 'Communications Equipment, Nec',
  '3671': 'Electron Tubes',
  '3672': 'Printed Circuit Boards',
  '3674': 'Semiconductors and Related Devices',
  '3675': 'Electronic Capacitors',
  '3676': 'Electronic Resistor',
  '3677': 'Electronic Coils and Transformers',
  '3678': 'Electronic Connectors',
  '3679': 'Electronic Components, Nec',
  '3691': 'Storage Batteries',
  '3692': 'Primary Batteries, Dry and Wet',
  '3694': 'Engine Electrical Equipment',
  '3695': 'Magnetic and Optical Recording Media',
  '3699': 'Electrical Equipment and Supplies, Nec',
  '3711': 'Motor Vehicles and Car Bodies',
  '3713': 'Truck and Bus Bodies',
  '3714': 'Motor Vehicle Parts and Accessories',
  '3715': 'Truck Trailers',
  '3716': 'Motor Home',
  '3721': 'Aircraft',
  '3724': 'Aircraft Engines and Engine Parts',
  '3728': 'Aircraft Parts and Equipment, Nec',
  '3731': 'Shipbuilding and Repairing',
  '3732': 'Boatbuilding and Repairing',
  '3743': 'Railroad Equipment',
  '3751': 'Motorcycles, Bicycles, and Parts',
  '3761': 'Guided Missiles and Space Vehicles',
  '3764': 'Space Propulsion Units and Parts',
  '3769': 'Space Vehicle Equipment, Ne',
  '3792': 'Travel Trailers and Campers',
  '3795': 'Tanks and Tank Components',
  '3799': 'Transportation Equipment, Nec',
  '3812': 'Search and Navigation Equipment',
  '3821': 'Laboratory Apparatus and Furniture',
  '3822': 'Environmental Controls',
  '3823': 'Process Control Instruments',
  '3824': 'Fluid Meters and Counting Devices',
  '3825': 'Instruments To Measure Electricity',
  '3826': 'Analytical Instruments',
  '3827': 'Optical Instruments and Lenses',
  '3829': 'Measuring and Controlling Devices, Nec',
  '3841': 'Surgical and Medical Instruments',
  '3842': 'Surgical Appliances and Supplies',
  '3843': 'Dental Equipment and Supplies',
  '3844': 'X-ray Apparatus and Tubes',
  '3845': 'Electromedical Equipment',
  '3851': 'Ophthalmic Goods',
  '3861': 'Photographic Equipment and Supplies',
  '3873': 'Watches, Clocks, Watchcases, and Parts',
  '3911': 'Jewelry, Precious Metal',
  '3914': 'Silverware, Plated Ware, and Stainless Steel Ware',
  '3915': "Jewelers' Findings and Materials, and Lapidary Work",
  '3931': 'Musiocal Instruments',
  '3942': 'Dolls and Stuffed Toys',
  '3944': "Games, Toys, and Children's Vehicles, Except Dolls and Bicycles",
  '3949': 'Sporting and Athletic Goods, Not Elsewhere Classified',
  '3951': 'Pens, Mechanical Pencils, and Parts',
  '3952': "Lead Pencils, Crayons, and Artists' Materials",
  '3953': 'Marking Devices',
  '3955': 'Carbon Paper and Inked Ribbons',
  '3961': 'Costume Jewelry and Costume Novelties, Except Previous Metals',
  '3965': 'Fasteners, Buttons, Needles, and Pins',
  '3991': 'Brooms and Brushes',
  '3993': 'Signs and Advertising Specialties',
  '3995': 'Burial Caskets',
  '3996': 'Linoleum, Asphalted-Felt-Base, and Other Hard Surface Floor Coverings, Not Elsewhere Classified',
  '3999': 'Manufacturing Indurstries, Not Elsewhere Classified',
  '4011': 'Railroads, Line-haul Operating',
  '4013': 'Switching and Terminal Services',
  '4111': 'Local and Suburban Transit',
  '4119': 'Local Passenger Transportation, Nec',
  '4121': 'Taxicabs',
  '4131': 'Intercity and Rural Bus Transportation',
  '4141': 'Local Bus Charter Service',
  '4142': 'Bus Charter Service, Except Local',
  '4151': 'School Buses',
  '4173': 'Bus Terminal and Service Facilities',
  '4212': 'Local Trucking, Without Storage',
  '4213': 'Trucking, Except Local',
  '4214': 'Local Trucking With Storage',
  '4215': 'Courier Services, Except By Air',
  '4221': 'Farm Product Warehousing and Storage',
  '4222': 'Refrigerated Warehousing and Storage',
  '4225': 'General Warehousing and Storage',
  '4226': 'Special Warehousing and Storage, Nec',
  '4231': 'Trucking Terminal Facilities',
  '4311': 'U.S. Postal Service',
  '4412': 'Deep Sea Foreign Transportation of Freight',
  '4424': 'Deep Sea Domestic Transportation of Freight',
  '4432': 'Freight Transportation On The Great Lakes',
  '4449': 'Water Transportation of Freight',
  '4481': 'Deep Sea Passenger Transportation, Except Ferry',
  '4482': 'Ferries',
  '4489': 'Water Passenger Transportation',
  '4491': 'Marine Cargo Handling',
  '4492': 'Towing and Tugboat Service',
  '4493': 'Marinas',
  '4499': 'Water Transportation Services, Nec',
  '4512': 'Air Transportation, Scheduled',
  '4513': 'Air Courier Services',
  '4522': 'Air Transportation, Nonscheduled',
  '4581': 'Airports, Flying Fields, and Services',
  '4612': 'Crude Petroleum Pipelines',
  '4613': 'Refined Petroleum Pipelines',
  '4619': 'Pipelines, Nec',
  '4724': 'Travel Agencies',
  '4725': 'Tour Operators',
  '4729': 'Passenger Transportation Arrangement',
  '4731': 'Freight Transportation Arrangement',
  '4741': 'Rental of Railroad Cars',
  '4783': 'Packing and Crating',
  '4785': 'Inspection and Fixed Facilities',
  '4789': 'Transportation Services, Nec',
  '4812': 'Radiotelephone Communication',
  '4813': 'Telephone Communication, Except Radio',
  '4822': 'Telegraph and Other Communications',
  '4832': 'Radio Broadcasting Stations',
  '4833': 'Television Broadcasting Stations',
  '4841': 'Cable and Other Pay Television Services',
  '4899': 'Communication Services, Nec',
  '4911': 'Electric Services',
  '4922': 'Natural Gas Transmission',
  '4923': 'Natural Gas Transmission and Distribution',
  '4924': 'Natural Gas Distribution',
  '4925': 'Mixed, Manufactured, or Liquefied Petroleum Gas Production and/or',
  '4931': 'Electric and Other Services Combined',
  '4932': 'Gas and Other Services Combined',
  '4939': 'Combination Utilities, Not Elsewhere Classified',
  '4941': 'Water Supply',
  '4952': 'Sewerage Systems',
  '4953': 'Refuse Systems',
  '4959': 'Sanitary Services, Not Elsewhere Classified',
  '4961': 'Steam and Air-Conditioning Supply',
  '4971': 'Irrigation Systems',
  '5012': 'Automobiles and Other Motor Vehicles',
  '5013': 'Motor Vehicle Supplies and New Parts',
  '5014': 'Tires and Tubes',
  '5015': 'Motor Vehicle Parts, Used',
  '5021': 'Furniture',
  '5023': 'Homefurnishings',
  '5031': 'Lumber, Plywood, and Millwork',
  '5032': 'Brick, Stone, and Related Material',
  '5033': 'Roofing, Siding, and Insulation',
  '5039': 'Construction Materials, Nec',
  '5043': 'Photographic Equipment and Supplies',
  '5044': 'Office Equipment',
  '5045': 'Computers, Peripherals, and Software',
  '5046': 'Commercial Equipment, Nec',
  '5047': 'Medical and Hospital Equipment',
  '5048': 'Ophthalmic Goods',
  '5049': 'Professional Equipment, Nec',
  '5051': 'Metals Service Centers and Offices',
  '5052': 'Coal and Other Minerals and Ores',
  '5063': 'Electrical Apparatus and Equipment',
  '5064': 'Electrical Appliances, Television and Radio',
  '5065': 'Electronic Parts and Equipment, Nec',
  '5072': 'Hardware',
  '5074': 'Plumbing and Hydronic Heating Supplies',
  '5075': 'Warm Air Heating and Air Conditioning',
  '5078': 'Refrigeration Equipment and Supplies',
  '5082': 'Construction and Mining Machinery',
  '5083': 'Farm and Garden Machinery',
  '5084': 'Industrial Machinery and Equipment',
  '5085': 'Industrial Supplies',
  '5087': 'Service Establishment Equipment',
  '5088': 'Transportation Equipment and Supplies',
  '5091': 'Sporting and Recreation Goods',
  '5092': 'Toys and Hobby Goods and Supplies',
  '5093': 'Scrap and Waste Materials',
  '5094': 'Jewelry and Precious Stones',
  '5099': 'Durable Goods, Nec',
  '5111': 'Printing and Writing Paper',
  '5112': 'Stationery and Office Supplies',
  '5113': 'Industrial and Personal Service Paper',
  '5122': "Drugs, Drug Proprietaries, and Druggists' Sundries",
  '5131': 'Piece Goods, Notions, and Other Dry Good',
  '5136': "Men's and Boy's Clothing and Furnishings",
  '5137': "Women's, Children's, and Infants' Clothing and Accessories",
  '5139': 'Footwear',
  '5141': 'Groceries, General Line',
  '5142': 'Packaged Frozen Foods',
  '5143': 'Dairy Products, Except Dried or Canned',
  '5144': 'Poultry and Poultry Products',
  '5145': 'Confectionery',
  '5146': 'Fish and Seafoods',
  '5147': 'Meats and Meat Products',
  '5148': 'Fresh Fruits and Vegetables',
  '5149': 'Groceries and Related Products, Not Elsewhere Classified',
  '5153': 'Grain and Field Beans',
  '5154': 'Livestock',
  '5159': 'Farm-Product Raw Materials, Not Elsewhere Classified',
  '5162': 'Plastics Materials and Basic Forms and Shapes',
  '5169': 'Chemicals and Allied Products, Not Elsewhere Classified',
  '5171': 'Petroleum Bulk stations and Terminals',
  '5172': 'Petroleum and Petroleum Products Wholesalers, Except Bulk Stations and Terminals',
  '5181': 'Beer and Ale',
  '5182': 'Wine and Distilled Alcoholic Beverages',
  '5191': 'Farm Supplies',
  '5192': 'Books, Periodicals, and Newspapers',
  '5193': "Flowers, Nursery Stock, and Florists' Supplies",
  '5194': 'Tobacco and Tobacco Products',
  '5198': 'Paints, Varnishes, and Supplies',
  '5199': 'Nondurable Goods, Not Elsewhere Classified',
  '5211': 'Lumber and Other Building Materials',
  '5231': 'Paint, Glass, and Wallpaper Stores',
  '5251': 'Hardware Stores',
  '5261': 'Retail Nurseries and Garden Stores',
  '5271': 'Mobile Home Dealers',
  '5311': 'Department Stores',
  '5331': 'Variety Stores',
  '5399': 'Miscellaneous General Merchandise',
  '5411': 'Grocery Stores',
  '5421': 'Meat and Fish Markets',
  '5431': 'Fruit and Vegetable Markets',
  '5441': 'Candy, Nut, and Confectionery Stores',
  '5451': 'Dairy Products Stores',
  '5461': 'Retail Bakeries',
  '5499': 'Miscellaneous Food Stores',
  '5511': 'New and Used Car Dealers',
  '5521': 'Used Car Dealers',
  '5531': 'Auto and Home Supply Stores',
  '5541': 'Gasoline Service Stations',
  '5551': 'Boat Dealers',
  '5561': 'Recreational Vehicle Dealers',
  '5571': 'Motorcycle Dealers',
  '5599': 'Automotive Dealers, Nec',
  '5611': "Men's and Boys' Clothing Stores",
  '5621': "Women's Clothing Stores",
  '5632': "Women's Accessory and Specialty Stores",
  '5641': "Children's and Infants' Wear Stores",
  '5651': 'Family Clothing Stores',
  '5661': 'Shoe Stores',
  '5699': 'Miscellaneous Apparel and Accessories',
  '5712': 'Furniture Stores',
  '5713': 'Floor Covering Stores',
  '5714': 'Drapery and Upholstery Stores',
  '5719': 'Miscellaneous Homefurnishings',
  '5722': 'Household Appliance Stores',
  '5731': 'Radio, Television, and Electronic Stores',
  '5734': 'Computer and Software Stores',
  '5735': 'Record and Prerecorded Tape Stores',
  '5736': 'Musical Instrument Stores',
  '5812': 'Eating Places',
  '5813': 'Drinking Places',
  '5912': 'Drug Stores and Proprietary Stores',
  '5921': 'Liquor Stores',
  '5932': 'Used Merchandise Stores',
  '5941': 'Sporting Goods Stores and Bicycle Shops',
  '5942': 'Book Stores',
  '5943': 'Stationery Stores',
  '5944': 'Jewelry Stores',
  '5945': 'Hobby, Toy, and Game Shops',
  '5946': 'Camera and Photographic Supply Stores',
  '5947': 'Gift, Novelty, and Souvenir Shops',
  '5948': 'Luggage and Leather Goods Stores',
  '5949': 'Sewing, Needlework, and Piece Goods Stores',
  '5961': 'Catalog and Mail-Order Houses',
  '5962': 'Automatic Merchandising Machine Operators',
  '5963': 'Direct Selling Establishments',
  '5983': 'Fuel Oil Dealers',
  '5984': 'Liquefied Petroleum Gas (Bottled Gas) Dealers',
  '5989': 'Fuel Dealers, Not Elsewhere Classified',
  '5992': 'Florists',
  '5993': 'Tobacco Stores and Stands',
  '5994': 'News Dealers and Newsstands',
  '5995': 'Optical Goods Stores',
  '5999': 'Miscellaneous Retail Stores, Not Elsewhere Classified',
  '6011': 'Federal Reserve Banks',
  '6019': 'Central Reserve Depository, Nec',
  '6021': 'National Commercial Banks',
  '6022': 'State Commercial Banks',
  '6029': 'Commercial Banks, Nec',
  '6035': 'Federal Savings Institutions',
  '6036': 'Savings Institutions, Except Federal',
  '6061': 'Federal Credit Unions',
  '6062': 'State Credit Unions',
  '6081': 'Foreign Bank and Branches and Agencies',
  '6082': 'Foreign Trade and International Banks',
  '6091': 'Nondeposit Trust Facilities',
  '6099': 'Functions Related To Depository Banking',
  '6111': 'Federal and Federally Sponsored Credit',
  '6141': 'Personal Credit Institutions',
  '6153': 'Short-term Business Credit',
  '6159': 'Miscellaneous Business Credit',
  '6162': 'Mortgage Bankers and Correspondents',
  '6163': 'Loan Brokers',
  '6211': 'Security Brokers and Dealers',
  '6221': 'Commodity Contracts Brokers, Dealers',
  '6231': 'Security and Commodity Exchanges',
  '6282': 'Investment Advice',
  '6289': 'Security and Commodity Service',
  '6311': 'Life Insurance',
  '6321': 'Accident and Health Insurance',
  '6324': 'Hospital and Medical Service Plans',
  '6331': 'Fire, Marine, and Casualty Insurance',
  '6351': 'Surety Insurance',
  '6361': 'Title Insurance',
  '6371': 'Pension, Health, and Welfare Funds',
  '6399': 'Insurance Carriers, Nec',
  '6411': 'Insurance Agents, Brokers, and Service',
  '6512': 'Nonresidential Building Operators',
  '6513': 'Apartment Building Operators',
  '6514': 'Dwelling Operators, Except Apartments',
  '6515': 'Mobile Home Site Operators',
  '6517': 'Railroad Property Lessors',
  '6519': 'Real Property Lessors, Nec',
  '6531': 'Real Estate Agents and Managers',
  '6541': 'Title abstract Offices',
  '6552': 'Subdividers and Developers, Nec',
  '6553': 'Cemetery Subdividers and Developers',
  '6712': 'Offices of Bank Holding Companies',
  '6719': 'Offices of Holding Companies, Not Elsewhere Classified',
  '6722': 'Management Investment Offices, Open-End',
  '6726': 'Unit Investment Trusts, Face-Amount Certificate Offices, and Closed-End Management Investment Offices',
  '6732': 'Educational, Religious, and Charitable Trusts',
  '6733': 'Trusts, Except Educational, Religious, and Charitable',
  '6792': 'Oil Royalty Traders',
  '6794': 'Patent Owners and Lessors',
  '6798': 'Real Estate Investment Trusts',
  '6799': 'Investors, Not Elsewhere Classified',
  '7011': 'Hotels and Motels',
  '7021': 'Rooming and Boarding Houses',
  '7032': 'Sporting and Recreational Camps',
  '7033': 'Trailer Parks and Campsites',
  '7041': 'Membership-basis Organization Hotels',
  '7211': 'Power Laundries, Family and Commercial',
  '7212': "Garment Pressing and Cleaners' Agents",
  '7213': 'Linen Supply',
  '7215': 'Coin-operated Laundries and Cleaning',
  '7216': 'Drycleaning Plants, Except Rugs',
  '7217': 'Carpet and Upholstery Cleaning',
  '7218': 'Industrial Launderers',
  '7219': 'Laundry and Garment Services, Nec',
  '7221': 'Photographic Studios, Portrait',
  '7231': 'Beauty Shops',
  '7241': 'Barber Shops',
  '7251': 'Shoe Repair and Shoeshine Parlors',
  '7261': 'Funeral Service and Crematories',
  '7291': 'Tax Return Preparation Services',
  '7299': 'Miscellaneous Personal Services',
  '7311': 'Advertising Agencies',
  '7312': 'Outdoor Advertising Services',
  '7313': 'Radio, Television, Publisher Representatives',
  '7319': 'Advertising, Nec',
  '7322': 'Adjustment and Collection Services',
  '7323': 'Credit Reporting Services',
  '7331': 'Direct Mail Advertising Services',
  '7334': 'Photocopying and Duplicating Services',
  '7335': 'Commercial Photography',
  '7336': 'Commercial Art and Graphic Design',
  '7338': 'Secretarial and Court Reporting',
  '7342': 'Disinfecting and Pest Control Services',
  '7349': 'Building Maintenance Services, Nec',
  '7352': 'Medical Equipment Rental',
  '7353': 'Heavy Construction Equipment Rental',
  '7359': 'Equipment Rental and Leasing, Nec',
  '7361': 'Employment Agencies',
  '7363': 'Help Supply Services',
  '7371': 'Custom Computer Programming Services',
  '7372': 'Prepackaged Software',
  '7373': 'Computer Integrated Systems Design',
  '7374': 'Data Processing and Preparation',
  '7375': 'Information Retrieval Services',
  '7376': 'Computer Facilities Management',
  '7377': 'Computer Rental and Leasing',
  '7378': 'Computer Maintenance and Repair',
  '7379': 'Computer Related Services, Nec',
  '7381': 'Detective and Armored Car Services',
  '7382': 'Security Systems Services',
  '7383': 'News Syndicates',
  '7384': 'Photofinish Laboratories',
  '7389': 'Business Services, Nec',
  '7513': 'Truck Rental and Leasing, Without Drivers',
  '7514': 'Passenger Car Rental',
  '7515': 'Passenger Car Leasing',
  '7519': 'Utility Trailer Rental',
  '7521': 'Automobile Parking',
  '7532': 'Top and Body Repair and Paint Shops',
  '7533': 'Auto Exhaust System Repair Shops',
  '7534': 'Tire Retreading and Repair Shops',
  '7536': 'Automotive Glass Replacement Shops',
  '7537': 'Automotive Transmission Repair Shops',
  '7538': 'General Automotive Repair Shops',
  '7539': 'Automotive Repair Shops, Nec',
  '7542': 'Carwashes',
  '7549': 'Automotive Services, Nec',
  '7622': 'Radio and Television Repair',
  '7623': 'Refrigeration Service and Repair',
  '7629': 'Electrical Repair Shops',
  '7631': 'Watch, Clock, and Jewelry Repair',
  '7641': 'Reupholstery and Furniture Repair',
  '7692': 'Welding Repair',
  '7694': 'Armature Rewinding Shops',
  '7699': 'Repair Services, Nec',
  '7812': 'Motion Picture and Video Production',
  '7819': 'Services Allied To Motion Pictures',
  '7822': 'Motion Picture and Tape Distribution',
  '7829': 'Motion Picture Distribution Services',
  '7832': 'Motion Picture Theaters, Except Drive-in',
  '7833': 'Drive-in Motion Picture Theaters',
  '7841': 'Video Tape Rental',
  '7911': 'Dance Studios, Schools, and Halls',
  '7922': 'Theatrical Producers and Services',
  '7929': 'Entertainers and Entertainment Groups',
  '7933': 'Bowling Centers',
  '7941': 'Sports Clubs, Managers, and Promoters',
  '7948': 'Racing, Including Track Operation',
  '7991': 'Physical Fitness Facilities',
  '7992': 'Public Golf Courses',
  '7993': 'Coin-operated Amusement Devices',
  '7996': 'Amusement Parks',
  '7997': 'Membership Sports and Recreation Clubs',
  '7999': 'Amusement and Recreation, Nec',
  '8011': 'Offices and Clinics of Medical Doctors',
  '8021': 'Offices and Clinics of Dentists',
  '8031': 'Offices and Clinics of Osteopathic Physicians',
  '8041': 'Offices and Clinics of Chiropractors',
  '8042': 'Offices and Clinics of Optometrists',
  '8043': 'Offices and Clinics of Podiatrists',
  '8049': 'Offices of Health Practitioner',
  '8051': 'Skilled Nursing Care Facilities',
  '8052': 'Intermediate Care Facilities',
  '8059': 'Nursing and Personal Care, Nec',
  '8062': 'General Medical and Surgical Hospitals',
  '8063': 'Psychiatric Hospitals',
  '8069': 'Specialty Hospitals, Except Psychiatric',
  '8071': 'Medical Laboratories',
  '8072': 'Dental Laboratories',
  '8082': 'Home Health Care Services',
  '8092': 'Kidney Dialysis Centers',
  '8093': 'Specialty Outpatient Clinics, Nec',
  '8099': 'Health and Allied Services, Nec',
  '8111': 'Legal Services',
  '8211': 'Elementary and Secondary Schools',
  '8221': 'Colleges and Universities',
  '8222': 'Junior Colleges',
  '8231': 'Libraries',
  '8243': 'Data Processing Schools',
  '8244': 'Business and Secretarial Schools',
  '8249': 'Vocational Schools, Nec',
  '8299': 'Schools and Educational Services',
  '8322': 'Individual and Family Services',
  '8331': 'Job Training and Related Services',
  '8351': 'Child Day Care Services',
  '8361': 'Residential Care',
  '8399': 'Social Services, Nec',
  '8412': 'Museums and Art Galleries',
  '8422': 'Botanical and Zoological Gardens',
  '8611': 'Business Associations',
  '8621': 'Professional Organizations',
  '8631': 'Labor Organizations',
  '8641': 'Civic and Social Associations',
  '8651': 'Political Organizations',
  '8661': 'Religious Organizations',
  '8699': 'Membership Organizations, Nec',
  '8711': 'Engineering Services',
  '8712': 'Architectural Services',
  '8713': 'Surveying Services',
  '8721': 'Accounting, Auditing, and Bookkeeping',
  '8731': 'Commercial Physical Research',
  '8732': 'Commercial Nonphysical Research',
  '8733': 'Noncommercial Research Organizations',
  '8734': 'Testing Laboratories',
  '8741': 'Management Services',
  '8742': 'Management Consulting Services',
  '8743': 'Public Relations Services',
  '8744': 'Facilities Support Services',
  '8748': 'Business Consulting, Nec',
  '8999': 'Services, Not Elsewhere Classified',
  '9111': 'Executive Offices',
  '9121': 'Legislative Bodies',
  '9131': 'Executive and Legislative Combined',
  '9199': 'General Government, Nec',
  '9211': 'Courts',
  '9221': 'Police Protection',
  '9222': 'Legal Counsel and Prosecution',
  '9223': 'Correctional Institutions',
  '9224': 'Fire Protection',
  '9229': 'Public Order and Safety, Nec',
  '9311': 'Finance, Taxation, and Monetary Policy',
  '9411': 'Administration of Educational Programs',
  '9431': 'Administration of Public Health Programs',
  '9441': 'Administration of Social and Manpower Programs',
  '9451': "Administration of Veterans' Affairs",
  '9511': 'Air, Water, and Solid Waste Management',
  '9512': 'Land, Mineral, and Wildlife Conservation',
  '9531': 'Housing Programs',
  '9532': 'Urban and Community Development',
  '9611': 'Administration of General Economic Programs',
  '9621': 'Regulation, Administration of Transportation',
  '9631': 'Regulation, Administration of Utilities',
  '9641': 'Regulation of Agricultural Marketing',
  '9651': 'Regulation, Miscellaneous Commercial Sectors',
  '9661': 'Space Research and Technology',
  '9711': 'National Security',
  '9721': 'International Affairs',
  '9999': 'Nonclassifiable Establishments'
};

export const INVESTMENT_TYPE_MAP = new Map([
  [0, 'Core'],
  [1, 'Core Plus'],
  [3, 'Opportunistic'],
  [2, 'Value Add'],
  [4, 'Distressed']
]);

export const USA_CENTER = {
  lat: 44.967243,
  lng: -103.771556
};

export const USA_BOUNDING_BOX = {
  latMin: 20,
  latMax: 45,
  lngMin: -120,
  lngMax: -70
};

export const WEST_COAST = {
  'type': 'Polygon',
  'label': 'West Coast',
  'coordinates': [
    [
      [-140.987549, 60.302464],
      [-140.993042, 69.843408],
      [-141.646729, 70.02997],
      [-142.954102, 70.318738],
      [-153.171387, 71.732662],
      [-157.983398, 71.760191],
      [-167.34375, 70.095529],
      [-168.266602, 66.82652],
      [-168.925781, 65.946472],
      [-169.453125, 65.676381],
      [-169.628906, 65.403445],
      [-169.848633, 64.623877],
      [-172.705078, 63.646259],
      [-175.253906, 60.435542],
      [-180, 50.903033],
      [-175.429688, 46.679594],
      [-174.375, 36.173357],
      [-172.265625, 5.266008],
      [-157.5, 5.266008],
      [-146.953125, 12.726084],
      [-123.925781, 24.846565],
      [-116.894531, 32.398516],
      [-114.697266, 32.62087],
      [-114.521484, 33.541395],
      [-114.082031, 34.198173],
      [-114.65332, 35.209722],
      [-120.014648, 38.993572],
      [-119.882813, 42.032974],
      [-116.982422, 42.065607],
      [-116.894531, 43.897892],
      [-116.828613, 44.229457],
      [-117.158203, 44.386692],
      [-116.828613, 44.777936],
      [-116.455078, 45.490946],
      [-116.345215, 46.103709],
      [-116.850586, 47.309034],
      [-116.982422, 48.719961],
      [-116.982422, 49.037868],
      [-123.299561, 48.99824],
      [-122.991943, 48.824949],
      [-122.991943, 48.748945],
      [-123.228149, 48.701838],
      [-123.156738, 48.447422],
      [-123.173218, 48.381794],
      [-123.338013, 48.290503],
      [-123.535767, 48.228332],
      [-123.865356, 48.301467],
      [-124.282837, 48.370848],
      [-124.595947, 48.461995],
      [-125.002441, 48.527519],
      [-125.293579, 48.523881],
      [-127.265625, 49.696062],
      [-128.232422, 49.922935],
      [-128.671875, 50.597186],
      [-130.429688, 51.316881],
      [-133.681641, 53.435719],
      [-133.494873, 54.521081],
      [-133.033447, 54.584797],
      [-130.550537, 54.718275],
      [-130.056152, 55.222757],
      [-129.935303, 55.795105],
      [-130.012207, 56.133307],
      [-130.297852, 56.170023],
      [-130.473633, 56.267761],
      [-130.737305, 56.340901],
      [-131.044922, 56.46249],
      [-131.352539, 56.644147],
      [-131.682129, 56.764768],
      [-131.835938, 57.052682],
      [-132.077637, 57.243394],
      [-132.253418, 57.456771],
      [-132.758789, 57.984808],
      [-132.978516, 58.367156],
      [-134.384766, 59.389178],
      [-135.32959, 59.899958],
      [-136.252441, 59.76746],
      [-136.889648, 59.422728],
      [-137.241211, 59.265881],
      [-137.768555, 59.723177],
      [-138.515625, 60.283408],
      [-139.042969, 60.522158],
      [-140.185547, 60.403002],
      [-140.987549, 60.302464]
    ]
  ]
};



export const WESTERN_US = {
  'type': 'Polygon',
  'label': 'Western US',
  'coordinates': [
    [
      [-124.969482, 48.502048],
      [-124.766235, 48.502048],
      [-123.997192, 48.330691],
      [-123.744507, 48.264913],
      [-123.31604, 48.275882],
      [-123.184204, 48.381794],
      [-123.244629, 48.545705],
      [-123.272095, 48.680081],
      [-122.997437, 48.777913],
      [-123.030396, 48.857487],
      [-123.321533, 49.001844],
      [-104.048767, 49.001844],
      [-104.036407, 44.996854],
      [-104.05632, 44.996854],
      [-104.052887, 41.002703],
      [-102.051659, 41.002184],
      [-102.035522, 36.998166],
      [-103.007813, 36.998166],
      [-103.001976, 36.500253],
      [-103.041458, 36.500391],
      [-103.063431, 31.999924],
      [-106.615448, 31.999924],
      [-106.631927, 31.988277],
      [-106.642914, 31.985948],
      [-106.632614, 31.972551],
      [-106.618881, 31.973716],
      [-106.620941, 31.960318],
      [-106.614075, 31.954784],
      [-106.615105, 31.950123],
      [-106.620255, 31.942549],
      [-106.625748, 31.927107],
      [-106.609955, 31.920113],
      [-106.615105, 31.915159],
      [-106.625061, 31.913702],
      [-106.632271, 31.911079],
      [-106.646004, 31.899712],
      [-106.643944, 31.893883],
      [-106.637077, 31.892425],
      [-106.630211, 31.887761],
      [-106.627808, 31.881931],
      [-106.631927, 31.875517],
      [-106.634331, 31.871143],
      [-106.635103, 31.86728],
      [-106.627979, 31.861886],
      [-106.625662, 31.859553],
      [-106.625834, 31.857731],
      [-106.614418, 31.847232],
      [-106.607208, 31.847159],
      [-106.600857, 31.844316],
      [-106.601028, 31.839649],
      [-106.602917, 31.836441],
      [-106.604741, 31.829185],
      [-106.604483, 31.828894],
      [-106.605062, 31.828073],
      [-106.602101, 31.824573],
      [-106.593647, 31.824846],
      [-106.586394, 31.821528],
      [-106.585321, 31.819231],
      [-106.582704, 31.816605],
      [-106.581502, 31.81511],
      [-106.580944, 31.813761],
      [-106.576524, 31.81015],
      [-106.576223, 31.810333],
      [-106.570816, 31.810187],
      [-106.566567, 31.81336],
      [-106.562963, 31.812594],
      [-106.562748, 31.811208],
      [-106.558542, 31.810515],
      [-106.556826, 31.810223],
      [-106.555796, 31.810041],
      [-106.550474, 31.80829],
      [-106.548629, 31.80767],
      [-106.546354, 31.807452],
      [-106.543436, 31.80333],
      [-106.537256, 31.800121],
      [-106.536741, 31.798917],
      [-106.53511, 31.79775],
      [-106.533866, 31.796291],
      [-106.532836, 31.794248],
      [-106.531849, 31.792461],
      [-106.52936, 31.79206],
      [-106.526656, 31.789725],
      [-106.527128, 31.787391],
      [-106.527772, 31.785384],
      [-106.527429, 31.783998],
      [-106.527987, 31.783816],
      [-108.201599, 31.781882],
      [-108.209839, 31.332525],
      [-111.071777, 31.327833],
      [-114.807129, 32.49123],
      [-114.808502, 32.515552],
      [-114.810562, 32.531184],
      [-114.804382, 32.565333],
      [-114.803009, 32.594263],
      [-114.789276, 32.623762],
      [-114.761124, 32.646891],
      [-114.737778, 32.688509],
      [-114.719925, 32.719421],
      [-117.238541, 32.525974],
      [-119.102783, 32.10119],
      [-122.55249, 33.906896],
      [-122.980957, 35.353216],
      [-127.001953, 41.771312],
      [-127.441406, 45.767523],
      [-124.969482, 48.502048]
    ]
  ]
};


export const EAST_COAST = {
  'type': 'Polygon',
  'label': 'East Coast',
  'coordinates': [
    [
      [-81.650391, 24.106647],
      [-80.024414, 24.726875],
      [-79.562988, 25.819672],
      [-79.82666, 28.0235],
      [-80.760498, 30.420256],
      [-79.562988, 32.147711],
      [-77.607422, 32.694866],
      [-74.179688, 33.72434],
      [-70.751953, 37.439974],
      [-67.939453, 40.513799],
      [-67.324219, 43.644026],
      [-66.950684, 44.879228],
      [-67.151184, 45.15299],
      [-67.225342, 45.168484],
      [-67.269287, 45.180101],
      [-67.310486, 45.164611],
      [-67.2995, 45.143305],
      [-67.343445, 45.13168],
      [-67.483521, 45.272954],
      [-67.420349, 45.375302],
      [-67.505493, 45.48902],
      [-67.428589, 45.498647],
      [-67.450562, 45.602509],
      [-67.785645, 45.67932],
      [-67.791138, 47.06638],
      [-67.879028, 47.100045],
      [-67.922974, 47.163575],
      [-67.966919, 47.199044],
      [-68.041077, 47.245678],
      [-68.139954, 47.297859],
      [-68.15094, 47.325792],
      [-68.307495, 47.353711],
      [-68.348694, 47.35185],
      [-68.37616, 47.345337],
      [-68.385773, 47.330912],
      [-68.384743, 47.312293],
      [-68.384743, 47.291107],
      [-68.424911, 47.28575],
      [-68.470917, 47.293202],
      [-68.494949, 47.30205],
      [-68.534088, 47.291805],
      [-68.562927, 47.289476],
      [-68.582153, 47.292271],
      [-68.601379, 47.275502],
      [-68.606358, 47.268281],
      [-68.604469, 47.263621],
      [-68.608932, 47.255466],
      [-68.630047, 47.248824],
      [-68.664379, 47.246377],
      [-68.701115, 47.24428],
      [-68.717937, 47.245911],
      [-68.74712, 47.231342],
      [-68.783169, 47.223998],
      [-68.832607, 47.210007],
      [-68.862648, 47.193912],
      [-68.89801, 47.182013],
      [-68.907795, 47.184696],
      [-68.915176, 47.193912],
      [-68.936462, 47.205109],
      [-68.976288, 47.218635],
      [-69.036026, 47.24661],
      [-69.046326, 47.263854],
      [-69.044952, 47.271309],
      [-69.048386, 47.297394],
      [-69.049072, 47.309034],
      [-69.053879, 47.314621],
      [-69.054265, 47.375744],
      [-69.053965, 47.377604],
      [-69.05036, 47.378011],
      [-69.047828, 47.380888],
      [-69.043322, 47.382079],
      [-69.041262, 47.382253],
      [-69.039116, 47.383735],
      [-69.038301, 47.386176],
      [-69.040875, 47.388384],
      [-69.043236, 47.392655],
      [-69.025726, 47.404391],
      [-69.038773, 47.421351],
      [-69.049072, 47.431571],
      [-69.062805, 47.435055],
      [-69.067955, 47.432152],
      [-69.079285, 47.42681],
      [-69.092846, 47.429249],
      [-69.100056, 47.433081],
      [-69.106922, 47.436332],
      [-69.120312, 47.442253],
      [-69.133015, 47.445504],
      [-69.141598, 47.447478],
      [-69.159279, 47.453282],
      [-69.177818, 47.457809],
      [-69.195843, 47.457925],
      [-69.209919, 47.455603],
      [-69.214211, 47.45688],
      [-69.222622, 47.460246],
      [-69.225047, 47.459361],
      [-69.22878, 47.455908],
      [-69.996643, 46.695845],
      [-70.055866, 46.415967],
      [-70.056553, 46.414665],
      [-70.061016, 46.414488],
      [-70.063248, 46.414014],
      [-70.066595, 46.413364],
      [-70.086079, 46.410582],
      [-70.090714, 46.411352],
      [-70.096893, 46.40999],
      [-70.102644, 46.404842],
      [-70.103416, 46.398923],
      [-70.112686, 46.389096],
      [-70.119553, 46.386965],
      [-70.130539, 46.38057],
      [-70.129852, 46.372991],
      [-70.132942, 46.371095],
      [-70.142899, 46.371095],
      [-70.198517, 46.353563],
      [-70.235596, 46.323223],
      [-70.30014, 46.195042],
      [-70.267181, 46.13988],
      [-70.345459, 46.073231],
      [-70.339966, 45.93205],
      [-70.339966, 45.874712],
      [-70.427856, 45.809658],
      [-70.411377, 45.740693],
      [-70.477295, 45.690833],
      [-70.609131, 45.675482],
      [-70.72998, 45.540984],
      [-70.861816, 45.471688],
      [-71.268311, 45.336702],
      [-71.542969, 45.158801],
      [-71.51001, 45.003651],
      [-71.531982, 44.9784],
      [-71.51001, 44.918139],
      [-71.551208, 44.857816],
      [-71.639099, 44.775986],
      [-71.595154, 44.633482],
      [-71.600647, 44.516093],
      [-72.062073, 44.331707],
      [-72.092285, 44.123085],
      [-72.163696, 43.949327],
      [-72.394409, 43.651975],
      [-72.493286, 43.165123],
      [-72.592163, 42.787339],
      [-72.581177, 42.729866],
      [-73.265076, 42.740961],
      [-73.281555, 42.785323],
      [-73.267822, 42.851806],
      [-73.234863, 43.285203],
      [-73.223877, 43.500752],
      [-73.256836, 43.588349],
      [-73.388672, 43.588349],
      [-73.355713, 43.715535],
      [-73.311768, 43.842451],
      [-73.399658, 44.103365],
      [-73.311768, 44.276671],
      [-73.256836, 44.449468],
      [-73.322754, 44.995883],
      [-73.959961, 45.003651],
      [-74.674072, 45.003651],
      [-74.904785, 45.034715],
      [-75.640869, 44.653024],
      [-76.234131, 44.292401],
      [-76.420898, 44.182204],
      [-76.838379, 43.723475],
      [-78.706055, 43.675818],
      [-79.277344, 43.444943],
      [-79.07959, 42.85986],
      [-79.782715, 42.512602],
      [-80.524292, 42.322001],
      [-80.529785, 39.732538],
      [-79.453125, 39.639538],
      [-78.046875, 39.470125],
      [-78.936768, 38.784063],
      [-79.991455, 38.078366],
      [-80.169983, 37.803274],
      [-80.282593, 37.622934],
      [-80.348511, 37.505368],
      [-80.744019, 37.4138],
      [-81.309814, 37.260938],
      [-81.507568, 37.256566],
      [-81.68335, 37.239075],
      [-81.903076, 37.378888],
      [-81.968994, 37.51844],
      [-82.287598, 37.352693],
      [-82.694092, 37.160317],
      [-83.045654, 36.862043],
      [-83.605957, 36.589068],
      [-81.930542, 36.594581],
      [-81.920929, 36.61663],
      [-81.643524, 36.611118],
      [-81.677856, 36.589068],
      [-81.710815, 36.425703],
      [-81.754761, 36.368222],
      [-81.947021, 36.279707],
      [-82.584229, 35.969115],
      [-83.204956, 35.755428],
      [-83.869629, 35.424868],
      [-84.309082, 35.092945],
      [-84.320068, 34.985003],
      [-85.613708, 34.982753],
      [-85.215454, 33.008663],
      [-85.12207, 32.657876],
      [-85.019073, 32.535236],
      [-85.000534, 32.48428],
      [-85.006714, 32.437931],
      [-84.979248, 32.400835],
      [-85.020447, 32.340521],
      [-85.006714, 32.201181],
      [-85.094604, 31.982453],
      [-85.133057, 31.812229],
      [-85.100098, 31.578535],
      [-85.078125, 31.231592],
      [-85.03418, 31.024694],
      [-87.561035, 31.015279],
      [-87.659912, 30.836215],
      [-87.440186, 30.666266],
      [-87.462158, 30.382353],
      [-87.626953, 29.276816],
      [-86.52832, 24.287027],
      [-82.573242, 23.624395],
      [-81.650391, 24.106647]
    ]
  ]
};

export const NORTHEAST = {
  'type': 'Polygon',
  'label': 'Northeast',
  'coordinates': [
    [
      [-80.529785, 39.732538],
      [-79.453125, 39.639538],
      [-78.046875, 39.470125],
      [-77.717285, 38.462192],
      [-75.432129, 36.791691],
      [-72.499587, 35.564239],
      [-70.751953, 37.439974],
      [-67.939453, 40.513799],
      [-67.324219, 43.644026],
      [-66.950684, 44.879228],
      [-67.151184, 45.15299],
      [-67.225342, 45.168484],
      [-67.269287, 45.180101],
      [-67.310486, 45.164611],
      [-67.2995, 45.143305],
      [-67.343445, 45.13168],
      [-67.483521, 45.272954],
      [-67.420349, 45.375302],
      [-67.505493, 45.48902],
      [-67.428589, 45.498647],
      [-67.450562, 45.602509],
      [-67.785645, 45.67932],
      [-67.791138, 47.06638],
      [-67.879028, 47.100045],
      [-67.922974, 47.163575],
      [-67.966919, 47.199044],
      [-68.041077, 47.245678],
      [-68.139954, 47.297859],
      [-68.15094, 47.325792],
      [-68.307495, 47.353711],
      [-68.348694, 47.35185],
      [-68.37616, 47.345337],
      [-68.385773, 47.330912],
      [-68.384743, 47.312293],
      [-68.384743, 47.291107],
      [-68.424911, 47.28575],
      [-68.470917, 47.293202],
      [-68.494949, 47.30205],
      [-68.534088, 47.291805],
      [-68.562927, 47.289476],
      [-68.582153, 47.292271],
      [-68.601379, 47.275502],
      [-68.606358, 47.268281],
      [-68.604469, 47.263621],
      [-68.608932, 47.255466],
      [-68.630047, 47.248824],
      [-68.664379, 47.246377],
      [-68.701115, 47.24428],
      [-68.717937, 47.245911],
      [-68.74712, 47.231342],
      [-68.783169, 47.223998],
      [-68.832607, 47.210007],
      [-68.862648, 47.193912],
      [-68.89801, 47.182013],
      [-68.907795, 47.184696],
      [-68.915176, 47.193912],
      [-68.936462, 47.205109],
      [-68.976288, 47.218635],
      [-69.036026, 47.24661],
      [-69.046326, 47.263854],
      [-69.044952, 47.271309],
      [-69.048386, 47.297394],
      [-69.049072, 47.309034],
      [-69.053879, 47.314621],
      [-69.054265, 47.375744],
      [-69.053965, 47.377604],
      [-69.05036, 47.378011],
      [-69.047828, 47.380888],
      [-69.043322, 47.382079],
      [-69.041262, 47.382253],
      [-69.039116, 47.383735],
      [-69.038301, 47.386176],
      [-69.040875, 47.388384],
      [-69.043236, 47.392655],
      [-69.025726, 47.404391],
      [-69.038773, 47.421351],
      [-69.049072, 47.431571],
      [-69.062805, 47.435055],
      [-69.067955, 47.432152],
      [-69.079285, 47.42681],
      [-69.092846, 47.429249],
      [-69.100056, 47.433081],
      [-69.106922, 47.436332],
      [-69.120312, 47.442253],
      [-69.133015, 47.445504],
      [-69.141598, 47.447478],
      [-69.159279, 47.453282],
      [-69.177818, 47.457809],
      [-69.195843, 47.457925],
      [-69.209919, 47.455603],
      [-69.214211, 47.45688],
      [-69.222622, 47.460246],
      [-69.225047, 47.459361],
      [-69.22878, 47.455908],
      [-69.996643, 46.695845],
      [-70.055866, 46.415967],
      [-70.056553, 46.414665],
      [-70.061016, 46.414488],
      [-70.063248, 46.414014],
      [-70.066595, 46.413364],
      [-70.086079, 46.410582],
      [-70.090714, 46.411352],
      [-70.096893, 46.40999],
      [-70.102644, 46.404842],
      [-70.103416, 46.398923],
      [-70.112686, 46.389096],
      [-70.119553, 46.386965],
      [-70.130539, 46.38057],
      [-70.129852, 46.372991],
      [-70.132942, 46.371095],
      [-70.142899, 46.371095],
      [-70.198517, 46.353563],
      [-70.235596, 46.323223],
      [-70.30014, 46.195042],
      [-70.267181, 46.13988],
      [-70.345459, 46.073231],
      [-70.339966, 45.93205],
      [-70.339966, 45.874712],
      [-70.427856, 45.809658],
      [-70.411377, 45.740693],
      [-70.477295, 45.690833],
      [-70.609131, 45.675482],
      [-70.72998, 45.540984],
      [-70.861816, 45.471688],
      [-71.268311, 45.336702],
      [-71.542969, 45.158801],
      [-71.507263, 45.01336],
      [-71.819, 45.01239],
      [-72.191162, 45.008506],
      [-73.004837, 45.019185],
      [-73.959961, 45.003651],
      [-74.674072, 45.003651],
      [-74.904785, 45.034715],
      [-75.640869, 44.653024],
      [-76.234131, 44.292401],
      [-76.420898, 44.182204],
      [-76.838379, 43.723475],
      [-78.706055, 43.675818],
      [-79.277344, 43.444943],
      [-79.07959, 42.85986],
      [-79.782715, 42.512602],
      [-80.524292, 42.322001],
      [-80.529785, 39.732538]
    ]
  ]
};



export const EAST_OF_MS_RIVER = {
  'type': 'Polygon',
  'label': 'Eastern US',
  'coordinates': [
    [
      [-83.100586, 41.943149],
      [-83.023682, 42.277309],
      [-82.573242, 42.516651],
      [-82.353516, 43.012681],
      [-82.089844, 43.580391],
      [-82.463379, 45.259422],
      [-83.474121, 45.828799],
      [-87.583008, 48.078079],
      [-88.461914, 48.224673],
      [-89.296875, 48.04871],
      [-91.40625, 47.010226],
      [-92.548828, 46.468133],
      [-93.120117, 45.675482],
      [-92.8125, 44.496505],
      [-91.40625, 43.834527],
      [-91.054688, 42.875964],
      [-90.454559, 42.299151],
      [-90.347443, 42.1746],
      [-90.234833, 42.128784],
      [-90.182648, 42.056431],
      [-90.160675, 42.004407],
      [-90.181274, 41.954384],
      [-90.178528, 41.898188],
      [-90.195007, 41.870583],
      [-90.227966, 41.84092],
      [-90.631714, 41.529142],
      [-90.943451, 41.526058],
      [-91.186523, 41.393294],
      [-91.109619, 41.219986],
      [-91.035461, 41.104191],
      [-91.005249, 40.984045],
      [-91.104126, 40.772222],
      [-91.428223, 40.526327],
      [-91.516113, 40.134791],
      [-91.384277, 39.732538],
      [-90.98877, 39.410733],
      [-90.65918, 39.027719],
      [-90.241699, 37.991834],
      [-89.516602, 37.439974],
      [-89.556427, 37.267496],
      [-89.432831, 37.081476],
      [-89.272156, 36.91696],
      [-89.391632, 36.79279],
      [-89.511108, 36.668419],
      [-90.241699, 35.083956],
      [-91.010742, 33.870416],
      [-91.241455, 33.26625],
      [-91.312866, 32.087229],
      [-91.724854, 31.156408],
      [-91.241455, 30.287532],
      [-90.527344, 29.840644],
      [-89.813232, 29.449165],
      [-83.540039, 23.84565],
      [-80.266113, 24.20689],
      [-79.672852, 25.562265],
      [-79.321289, 27.547242],
      [-74.069824, 32.417066],
      [-72.499587, 35.564239],
      [-70.751953, 37.439974],
      [-67.939453, 40.513799],
      [-67.324219, 43.644026],
      [-66.950684, 44.879228],
      [-67.151184, 45.15299],
      [-67.225342, 45.168484],
      [-67.269287, 45.180101],
      [-67.310486, 45.164611],
      [-67.2995, 45.143305],
      [-67.343445, 45.13168],
      [-67.483521, 45.272954],
      [-67.420349, 45.375302],
      [-67.505493, 45.48902],
      [-67.428589, 45.498647],
      [-67.450562, 45.602509],
      [-67.785645, 45.67932],
      [-67.791138, 47.06638],
      [-67.879028, 47.100045],
      [-67.922974, 47.163575],
      [-67.966919, 47.199044],
      [-68.041077, 47.245678],
      [-68.139954, 47.297859],
      [-68.15094, 47.325792],
      [-68.307495, 47.353711],
      [-68.348694, 47.35185],
      [-68.37616, 47.345337],
      [-68.385773, 47.330912],
      [-68.384743, 47.312293],
      [-68.384743, 47.291107],
      [-68.424911, 47.28575],
      [-68.470917, 47.293202],
      [-68.494949, 47.30205],
      [-68.534088, 47.291805],
      [-68.562927, 47.289476],
      [-68.582153, 47.292271],
      [-68.601379, 47.275502],
      [-68.606358, 47.268281],
      [-68.604469, 47.263621],
      [-68.608932, 47.255466],
      [-68.630047, 47.248824],
      [-68.664379, 47.246377],
      [-68.701115, 47.24428],
      [-68.717937, 47.245911],
      [-68.74712, 47.231342],
      [-68.783169, 47.223998],
      [-68.832607, 47.210007],
      [-68.862648, 47.193912],
      [-68.89801, 47.182013],
      [-68.907795, 47.184696],
      [-68.915176, 47.193912],
      [-68.936462, 47.205109],
      [-68.976288, 47.218635],
      [-69.036026, 47.24661],
      [-69.046326, 47.263854],
      [-69.044952, 47.271309],
      [-69.048386, 47.297394],
      [-69.049072, 47.309034],
      [-69.053879, 47.314621],
      [-69.054265, 47.375744],
      [-69.053965, 47.377604],
      [-69.05036, 47.378011],
      [-69.047828, 47.380888],
      [-69.043322, 47.382079],
      [-69.041262, 47.382253],
      [-69.039116, 47.383735],
      [-69.038301, 47.386176],
      [-69.040875, 47.388384],
      [-69.043236, 47.392655],
      [-69.025726, 47.404391],
      [-69.038773, 47.421351],
      [-69.049072, 47.431571],
      [-69.062805, 47.435055],
      [-69.067955, 47.432152],
      [-69.079285, 47.42681],
      [-69.092846, 47.429249],
      [-69.100056, 47.433081],
      [-69.106922, 47.436332],
      [-69.120312, 47.442253],
      [-69.133015, 47.445504],
      [-69.141598, 47.447478],
      [-69.159279, 47.453282],
      [-69.177818, 47.457809],
      [-69.195843, 47.457925],
      [-69.209919, 47.455603],
      [-69.214211, 47.45688],
      [-69.222622, 47.460246],
      [-69.225047, 47.459361],
      [-69.22878, 47.455908],
      [-69.996643, 46.695845],
      [-70.055866, 46.415967],
      [-70.056553, 46.414665],
      [-70.061016, 46.414488],
      [-70.063248, 46.414014],
      [-70.066595, 46.413364],
      [-70.086079, 46.410582],
      [-70.090714, 46.411352],
      [-70.096893, 46.40999],
      [-70.102644, 46.404842],
      [-70.103416, 46.398923],
      [-70.112686, 46.389096],
      [-70.119553, 46.386965],
      [-70.130539, 46.38057],
      [-70.129852, 46.372991],
      [-70.132942, 46.371095],
      [-70.142899, 46.371095],
      [-70.198517, 46.353563],
      [-70.235596, 46.323223],
      [-70.30014, 46.195042],
      [-70.267181, 46.13988],
      [-70.345459, 46.073231],
      [-70.339966, 45.93205],
      [-70.339966, 45.874712],
      [-70.427856, 45.809658],
      [-70.411377, 45.740693],
      [-70.477295, 45.690833],
      [-70.609131, 45.675482],
      [-70.72998, 45.540984],
      [-70.861816, 45.471688],
      [-71.268311, 45.336702],
      [-71.542969, 45.158801],
      [-71.51001, 45.003651],
      [-71.531982, 44.9784],
      [-71.51001, 44.918139],
      [-71.551208, 44.857816],
      [-71.639099, 44.775986],
      [-71.595154, 44.633482],
      [-71.600647, 44.516093],
      [-72.062073, 44.331707],
      [-72.092285, 44.123085],
      [-72.163696, 43.949327],
      [-72.394409, 43.651975],
      [-72.493286, 43.165123],
      [-72.592163, 42.787339],
      [-72.581177, 42.729866],
      [-73.265076, 42.740961],
      [-73.281555, 42.785323],
      [-73.267822, 42.851806],
      [-73.234863, 43.285203],
      [-73.223877, 43.500752],
      [-73.256836, 43.588349],
      [-73.388672, 43.588349],
      [-73.355713, 43.715535],
      [-73.311768, 43.842451],
      [-73.399658, 44.103365],
      [-73.311768, 44.276671],
      [-73.256836, 44.449468],
      [-73.322754, 44.995883],
      [-73.959961, 45.003651],
      [-74.674072, 45.003651],
      [-74.904785, 45.034715],
      [-75.640869, 44.653024],
      [-76.234131, 44.292401],
      [-76.420898, 44.182204],
      [-76.838379, 43.723475],
      [-78.706055, 43.675818],
      [-79.277344, 43.444943],
      [-79.07959, 42.85986],
      [-79.782715, 42.512602],
      [-80.524292, 42.322001],
      [-81.584473, 42.065607],
      [-83.100586, 41.943149]
    ]
  ]
};



export const MIDWEST = {
  'type': 'Polygon',
  'label': 'Midwest',
  'coordinates': [
    [
      [-104.046021, 49.005447],
      [-104.039841, 44.997825],
      [-104.06044, 44.997339],
      [-104.040527, 41.004775],
      [-102.046509, 41.00063],
      [-102.041016, 39.985538],
      [-102.041016, 36.993778],
      [-94.603271, 36.993778],
      [-94.614258, 36.491973],
      [-90.164795, 36.500805],
      [-90.152435, 36.461054],
      [-90.149002, 36.423493],
      [-90.130463, 36.394757],
      [-90.098877, 36.385913],
      [-90.082397, 36.367116],
      [-90.09613, 36.321764],
      [-90.131836, 36.280814],
      [-90.170288, 36.233197],
      [-90.233459, 36.195525],
      [-90.271912, 36.152291],
      [-90.318604, 36.100157],
      [-90.387268, 36.040216],
      [-90.392761, 35.993563],
      [-89.711609, 35.998008],
      [-89.296875, 36.633162],
      [-88.769531, 36.985003],
      [-87.626953, 37.822802],
      [-84.814453, 38.719805],
      [-84.122314, 38.625454],
      [-83.430176, 38.530979],
      [-82.924805, 38.61687],
      [-82.397461, 38.307181],
      [-80.463867, 40.245992],
      [-80.535278, 42.065607],
      [-81.518555, 42.073762],
      [-82.452393, 41.681118],
      [-83.056641, 41.934977],
      [-82.858887, 42.256984],
      [-82.468872, 42.654162],
      [-82.391968, 43.032761],
      [-82.144775, 43.580391],
      [-82.617188, 45.367584],
      [-88.286133, 48.268569],
      [-89.318848, 48.034019],
      [-90.043945, 48.173412],
      [-90.461426, 48.144098],
      [-90.889893, 48.253941],
      [-91.494141, 48.151428],
      [-91.966553, 48.414619],
      [-93.153076, 48.69096],
      [-93.603516, 48.632909],
      [-93.999023, 48.69096],
      [-94.625244, 48.821333],
      [-94.855957, 49.37522],
      [-95.163574, 49.360912],
      [-95.152588, 49.001844],
      [-99.338379, 48.980217],
      [-104.046021, 49.005447]
    ]
  ]
};


export const SOUTH = {
  'type': 'Polygon',
  'label': 'South',
  'coordinates': [
    [
      [-97.558594, 25.958045],
      [-80.947266, 24.686952],
      [-79.848633, 25.005973],
      [-79.277344, 27.644606],
      [-78.068848, 30.145127],
      [-75.19043, 35.317366],
      [-75.629883, 36.791691],
      [-75.27832, 37.926868],
      [-78.112793, 38.608286],
      [-80.595703, 40.380028],
      [-81.090088, 39.444678],
      [-82.397461, 38.771216],
      [-82.595215, 38.410827],
      [-84.605713, 39.070379],
      [-85.935059, 38.134557],
      [-87.802734, 37.961523],
      [-89.099121, 36.897194],
      [-89.538574, 36.500805],
      [-94.570313, 36.527295],
      [-94.625244, 37.011326],
      [-103.040771, 36.993778],
      [-103.035278, 36.518466],
      [-103.183594, 31.952162],
      [-106.567383, 31.914868],
      [-105.161133, 30.448674],
      [-104.414063, 29.382175],
      [-103.156128, 28.492833],
      [-102.321167, 29.659416],
      [-101.568604, 29.726222],
      [-100.678711, 28.88316],
      [-99.09668, 26.431228],
      [-97.558594, 25.958045]
    ]
  ]
};


export const SOUTHWEST = {
  'type': 'Polygon',
  'label': 'Southwest',
  'coordinates': [
    [
      [-109.091037, 31.33549],
      [-108.193359, 31.353637],
      [-108.171387, 31.774878],
      [-106.567383, 31.793555],
      [-106.578369, 31.998759],
      [-103.078423, 32.012888],
      [-103.001519, 36.954426],
      [-102.041016, 36.985003],
      [-102.041016, 41.013066],
      [-109.088745, 41.021355],
      [-111.060791, 40.988192],
      [-111.049805, 42.000325],
      [-119.926758, 42.000325],
      [-119.882813, 39.027719],
      [-114.65332, 34.921971],
      [-114.559937, 33.72434],
      [-114.719238, 33.109948],
      [-114.818115, 32.49123],
      [-111.022339, 31.311408],
      [-109.091037, 31.33549]
    ]
  ]
};


export const SOUTHEAST = {
  'type': 'Polygon',
  'label': 'Southeast',
  'coordinates': [
    [
      [-84.814453, 39.095963],
      [-85.803223, 38.289937],
      [-87.802734, 37.857507],
      [-88.549805, 37.195331],
      [-89.060669, 36.980615],
      [-89.296875, 36.527295],
      [-89.549561, 35.748741],
      [-90.131836, 35.101934],
      [-90.648193, 34.50203],
      [-91.098633, 33.83392],
      [-91.054688, 32.249974],
      [-91.620483, 31.001155],
      [-89.719849, 31.001155],
      [-89.835205, 30.566991],
      [-89.533081, 30.18787],
      [-88.846436, 30.145127],
      [-86.11084, 29.42046],
      [-83.924561, 28.825425],
      [-83.38623, 26.92207],
      [-83.979492, 23.865745],
      [-80.595703, 24.367114],
      [-79.760742, 25.482951],
      [-80.068359, 31.25977],
      [-77.783203, 33.797409],
      [-75.432129, 34.759666],
      [-75.124512, 36.694851],
      [-74.597168, 39.095963],
      [-78.244629, 38.873929],
      [-79.387207, 39.402244],
      [-80.518799, 39.732538],
      [-80.639648, 40.580585],
      [-80.837402, 39.825413],
      [-81.452637, 39.385264],
      [-82.792969, 38.754083],
      [-84.814453, 39.095963]
    ]
  ]
};



export const NEW_ENGLAND = {
  'type': 'Polygon',
  'label': 'New England',
  'coordinates': [
    [
      [-73.35022, 45.015302],
      [-73.278809, 42.744995],
      [-73.509521, 42.065607],
      [-73.491669, 42.046233],
      [-73.476563, 41.046217],
      [-72.394409, 41.203456],
      [-71.861572, 41.302571],
      [-71.323242, 41.277806],
      [-70.004883, 41.079351],
      [-69.477539, 41.869561],
      [-70.180664, 42.5207],
      [-69.411621, 43.34116],
      [-68.005371, 43.707594],
      [-67.390137, 44.21371],
      [-66.928711, 44.684277],
      [-66.879272, 44.777936],
      [-67.153931, 45.143305],
      [-67.412109, 45.232349],
      [-67.384644, 45.452424],
      [-67.582397, 45.690833],
      [-67.774658, 45.935871],
      [-67.791138, 47.06638],
      [-67.884521, 47.107523],
      [-67.922974, 47.165442],
      [-67.961426, 47.215837],
      [-68.126221, 47.294134],
      [-68.25531, 47.355571],
      [-68.384399, 47.342545],
      [-68.486023, 47.288545],
      [-68.672791, 47.249407],
      [-68.863678, 47.209307],
      [-68.892517, 47.187846],
      [-69.049072, 47.424371],
      [-69.233093, 47.459666],
      [-69.99939, 46.694667],
      [-70.051575, 46.40567],
      [-70.08728, 46.407564],
      [-70.150452, 46.365884],
      [-70.20813, 46.341239],
      [-70.210876, 46.329862],
      [-70.210876, 46.301406],
      [-70.249329, 46.261544],
      [-70.279541, 46.196943],
      [-70.230103, 46.136073],
      [-70.250702, 46.103709],
      [-70.282288, 46.098948],
      [-70.294647, 46.075136],
      [-70.307007, 46.060844],
      [-70.280914, 46.060844],
      [-70.298767, 46.019853],
      [-70.301514, 45.993145],
      [-70.285034, 45.981695],
      [-70.301514, 45.966425],
      [-70.238342, 45.95115],
      [-70.235596, 45.935871],
      [-70.260315, 45.916766],
      [-70.260315, 45.874712],
      [-70.326233, 45.847934],
      [-70.397644, 45.809658],
      [-70.411377, 45.780933],
      [-70.389404, 45.727274],
      [-70.422363, 45.704261],
      [-70.469055, 45.702343],
      [-70.53772, 45.671644],
      [-70.603638, 45.623643],
      [-70.694275, 45.56791],
      [-70.735474, 45.512121],
      [-70.677795, 45.411948],
      [-70.801392, 45.463983],
      [-70.886536, 45.356005],
      [-71.015625, 45.392664],
      [-71.128235, 45.323186],
      [-71.317749, 45.346354],
      [-71.460571, 45.253622],
      [-71.507263, 45.017244],
      [-73.35022, 45.015302]
    ]
  ]
};



export const SUNBELT = {
  'type': 'Polygon',
  'label': 'Sunbelt',
  'coordinates': [
    [
      [-114.804382, 32.502813],
      [-111.071777, 31.327833],
      [-108.207092, 31.330179],
      [-108.207092, 31.784217],
      [-106.419067, 31.770208],
      [-106.21582, 31.473182],
      [-105.891724, 31.245682],
      [-105.254517, 30.734754],
      [-104.699707, 30.088108],
      [-104.611816, 29.51611],
      [-103.095703, 28.844674],
      [-102.65625, 29.61167],
      [-101.8927, 29.730992],
      [-101.030273, 29.406105],
      [-100.371094, 28.381735],
      [-99.511414, 27.518015],
      [-99.393311, 27.019984],
      [-99.052734, 26.401711],
      [-98.173828, 26.076521],
      [-96.547852, 25.839449],
      [-93.22998, 28.420391],
      [-89.25293, 28.149503],
      [-86.77002, 28.478349],
      [-84.199219, 27.25463],
      [-83.375245, 24.427145],
      [-81.386719, 23.644524],
      [-79.848633, 24.766785],
      [-79.145508, 27.722436],
      [-74.003906, 36.5626],
      [-81.5625, 36.5626],
      [-88.022461, 36.491973],
      [-89.472656, 36.421282],
      [-89.67041, 35.924645],
      [-90.32959, 35.88905],
      [-90.153809, 36.527295],
      [-94.504395, 36.474307],
      [-94.526367, 36.985003],
      [-101.99707, 36.976227],
      [-103.018799, 36.993778],
      [-109.050293, 37.002553],
      [-114.060059, 37.07271],
      [-114.191895, 36.049099],
      [-114.675293, 35.442771],
      [-114.499512, 34.687428],
      [-114.55307, 33.437171],
      [-114.678726, 32.971228],
      [-114.716492, 32.72722],
      [-114.801636, 32.597734],
      [-114.804382, 32.502813]
    ]
  ]
};

export const REGIONS = [
  WESTERN_US,
  WEST_COAST,
  EAST_COAST,
  MIDWEST,
  NORTHEAST,
  SOUTH,
  SOUTHWEST,
  SOUTHEAST,
  EAST_OF_MS_RIVER,
  SUNBELT,
  NEW_ENGLAND
];
